<template>
  <div></div>
</template>

<script>
import MallServiceApi from "@/api/mall";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
export default {
  data() {
    return {
      routerType: 0,
    };
  },
  mounted() {
    var that = this;
    if (userAgent.android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
    });
  },
  created() {
    this.routerType = this.$route.query.type;
    if (this.$route.query.qtype == 1) {
      if (userAgent.android) {
        this.$bridge.callmethod("closeContainer");
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "closeContainer",
          function (responseData) {}
        );
      }
    } else {
      if (this.routerType == 1) {
        let params = {
          source: 2,
          contractType: 3,
          params: window.location.href.split("contract")[0] + "contractHg",
          orderNo: this.$route.query.orderNo,
        };
        MallServiceApi.getExtsignV2(params).then((data) => {
          if (data.code == 200) {
            localStorage.setItem("htUrl", data.data);
            this.$router.push("/sdxpg?type=app&routeType=1");
          }
        });
      } else {
        this.getExtsign();
      }
    }
  },
  methods: {
    getExtsign() {
      let params = {
        source: 2,
        contractType: 3,
        params: window.location.href + "&qtype=1",
        orderNo: this.$route.query.orderNo,
        agreementId: this.$route.query.agreementId,
      };
      MallServiceApi.getExtsign(params).then((res) => {
        if (res.code == 200) {
          localStorage.setItem("htUrl", res.data);
          this.$router.push("/sdxpg?type=app&routeType=2");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>